import { createClient } from '@supabase/supabase-js';

// Fallback wartości (używane jeśli zmienne środowiskowe nie są dostępne)
// Anon key Supabase jest publiczny i bezpieczny do użycia w frontendzie
const DEFAULT_SUPABASE_URL = 'https://sxizcagjxpozpbkpmnnk.supabase.co';
const DEFAULT_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN4aXpjYWdqeHBvenBia3Btbm5rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk4ODkxNTYsImV4cCI6MjA4NTQ2NTE1Nn0.0oigg3yzBba4zSpnXevJHsKPzwlKxjqTaNaKP0-en9w';

// Użyj zmiennych środowiskowych jeśli dostępne, w przeciwnym razie użyj wartości domyślnych
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || DEFAULT_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || DEFAULT_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);